import { translate, tryTranslate } from "../i18n/index.js";
/**
 * نصّ الخطأ كما يقرؤه المستخدم — **الطريق الوحيد**.
 *
 * وسببُ وجوده أن `t(error.messageKey)` تبدو صحيحة وهي ناقصة: تُسقط السياق،
 * فرسالةٌ مثل «الملف {sizeMb} ميجا» تصل بالأقواس حرفياً. والنقص لا يظهر إلا
 * في الرسائل التي لها فراغات — أي في أسوأ لحظة، حين يكون المستخدم واقفاً
 * أمام فشل.
 *
 * فلا تُمرَّر المفاتيح إلى `t` مباشرةً: قاعدة lint تمنع ذلك، وهذه الدالة هي
 * البديل الوحيد.
 */
export function errorMessage(locale, error) {
    return translate(locale, error.messageKey, messageParams(locale, error));
}
/**
 * **الحالةُ تُقال بكلمتها، لا برمزها.**
 *
 * كان السيرفر يبعث `IN_PROGRESS` فتصل الرسالةُ «ليس في حالة تقبل قرار العميل (IN_PROGRESS)». والجدولُ
 * يقول لكل رسالةٍ فيها حالة أين كلماتُها، وبوّابةٌ في الاختبار تكسر البناء على رسالةٍ منسيّة.
 */
export const STATE_WORDS_OF = {
    "errors.cardTransitionNotAllowed": "cards.state.",
    "errors.planTransitionInvalid": "plans.state.",
    "errors.planTaskMoveInvalid": "plans.task.state.",
    "errors.planItemNotDecidable": "plans.state.",
    "errors.planPublishedEditRefused": "plans.state.",
    "errors.planCancelInvalidState": "plans.state.",
    "errors.planNotEditRequestable": "plans.state.",
    "errors.releaseStateInvalid": "platform.changelog.state.",
    "errors.meetingStateInvalid": "meetings.state.",
    "errors.reportLocked": "reports.state.",
    "errors.reportNotInReview": "reports.state.",
};
const STATE_PARAMS = new Set(["state", "from", "to"]);
function stateWord(locale, prefix, value) {
    const lower = value.toLowerCase();
    const camel = lower.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
    for (const form of [value, lower, camel, value.toUpperCase()]) {
        const word = tryTranslate(locale, `${prefix}${form}`);
        if (word !== undefined)
            return word;
    }
    return value;
}
/**
 * السياق يصل من السلك `unknown` — ويُقبل منه ما يُعرض للبشر فقط.
 *
 * فكائنٌ أو مصفوفة تصل إلى الشاشة `[object Object]`، وهو نصٌّ لا يقوله أحد
 * لأحد. وما لا يصلح للعرض يُترك فراغه ظاهراً بدل أن يُملأ بقمامة.
 */
function messageParams(locale, { messageKey, context }) {
    if (!context)
        return undefined;
    const params = {};
    const words = STATE_WORDS_OF[messageKey];
    for (const [key, value] of Object.entries(context)) {
        if (typeof value === "string" && words !== undefined && STATE_PARAMS.has(key)) {
            params[key] = stateWord(locale, words, value);
        }
        else if (typeof value === "string" || typeof value === "number") {
            params[key] = value;
        }
    }
    return params;
}
//# sourceMappingURL=text.js.map